<div class="background-theme">
  <router-outlet style="flex: 1 1"></router-outlet>
</div>
